var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FF405C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9972 14.7778L21.0912 5.87187C20.8973 5.67799 20.6295 5.55811 20.3336 5.55811H7.99475C7.40302 5.55811 6.92331 6.03787 6.92331 6.62955V23.3706C6.92331 23.6664 7.04325 23.9343 7.23714 24.1282L12.9713 29.8624C13.635 29.9525 14.312 30.0001 15 30.0001C23.361 30.0001 30.119 23.1363 29.9972 14.7778Z",
    fill: "#D01273"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0835 11.8326C22.6651 11.4142 21.9867 11.4142 21.5683 11.8326C21.1498 12.2511 21.1498 12.9295 21.5683 13.3479L22.1491 13.9287H14.7723C14.1805 13.9287 13.7009 14.4084 13.7009 15C13.7009 15.5918 14.1805 16.0715 14.7723 16.0715H22.1491L21.5683 16.6523C21.1498 17.0707 21.1498 17.7491 21.5683 18.1674C21.7775 18.3767 22.0516 18.4813 22.3258 18.4813C22.6001 18.4813 22.8742 18.3767 23.0834 18.1676L25.4932 15.7577C25.6942 15.5567 25.8071 15.2843 25.8071 15.0001C25.8071 14.7159 25.6942 14.4434 25.4932 14.2425L23.0835 11.8326Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.405 19.6711V23.3706C21.405 23.9623 20.9254 24.442 20.3336 24.442H7.99475C7.40302 24.442 6.92331 23.9623 6.92331 23.3706V6.62955C6.92331 6.03787 7.40296 5.55811 7.99475 5.55811H20.3337C20.9255 5.55811 21.4051 6.03787 21.4051 6.62955V10.329C21.4051 10.9208 20.9255 11.4005 20.3337 11.4005C19.7419 11.4005 19.2622 10.9207 19.2622 10.329V7.70094H9.06614V22.2992H19.2622V19.6711C19.2622 19.0794 19.7419 18.5996 20.3337 18.5996C20.9254 18.5997 21.405 19.0794 21.405 19.6711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingLogout);
export default __webpack_public_path__ + "static/media/setting_logout.f3f9d09a8ae27f4bb876ccb568205415.svg";
export { ForwardRef as ReactComponent };